import type { Page } from '../../types';

const suspectedWhistleBlowing: Page[] = [
  {
    pageType: 'question',
    title: 'Allegations of suspected whistleblowing',
    name: 'suspected-whistleblowing-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any allegations of suspected whistleblowing to declare?',
        name: 'fraud_allegations_whistleblowing_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Allegations of suspected whistleblowing',
    name: 'suspected-whistleblowing',
    type: 'nilreturn',
    fastToggle: true,
    disabled: [
      {
        field: 'fraud_allegations_whistleblowing_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'total_allegations',
        hint: 'If a value is not applicable, please enter 0',
        hideOptionalLabel: true,
        customValidation: {
          sumLessThanOrEqualToAnswers: [
            'fraud_allegations',
            'bribery_allegations',
          ],
        },
        errorMessages: {
          sumLessThanOrEqualToAnswers:
            'Total number of instances must not exceed the total of suspected fraud and suspected bribery instances',
        },
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'fraud_allegations_whistleblowing_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default suspectedWhistleBlowing;




